module.exports = __webpack_public_path__ + "img/42_10.da9efbe7.png";